var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "button",
    {
      staticClass: "ds-btn",
      class: ["ds-btn--" + _vm.variant, "ds-btn--" + _vm.size],
      attrs: { type: "button", disabled: _vm.disabled },
      on: {
        click: function ($event) {
          return _vm.$emit("click", $event)
        },
      },
    },
    [
      _vm.icon
        ? _c("ds-icon", { attrs: { name: _vm.icon, size: 18 } })
        : _vm._e(),
      _vm._t("default"),
      _vm.iconRight
        ? _c("ds-icon", { attrs: { name: _vm.iconRight, size: 18 } })
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }